import { useMemo } from 'react';
import { useQuery, useI18n } from '@ywwwtseng/react-kit';
import { Marquee } from './Marquee';

export function EventMarquee() {
  const { t } = useI18n();
  const { data: events } =
    useQuery<{ type: string; message: string }[]>('events');
  const messages = useMemo(() => {
    if (!events) return [];

    return (
      events.map((event) => {
        const text = t(
          `event.${event.type}`,
          JSON.parse(event.message) as Record<string, string | number>
        );

        return {
          text,
          event,
        };
      })
    );
  }, [events, t]);

  return (
    <Marquee messages={messages} speed={80} className="w-full min-h-10 py-2" />
  );
}
